import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Alert
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { ASSUMPTIONS, DISCLAIMER } from '../../utils/costRates';

const AssumptionsDisclaimer = ({ language = 'en' }) => {
  const content = {
    en: {
      assumptionsTitle: 'Estimation Assumptions',
      basedOn: 'This estimation is based on:',
      excludes: 'This estimation EXCLUDES:',
      disclaimerTitle: 'Important Disclaimer'
    },
    my: {
      assumptionsTitle: 'Andaian Anggaran',
      basedOn: 'Anggaran ini berdasarkan:',
      excludes: 'Anggaran ini TIDAK TERMASUK:',
      disclaimerTitle: 'Penafian Penting'
    }
  };

  const t = content[language] || content.en;
  const disclaimer = DISCLAIMER[language] || DISCLAIMER.en;

  return (
    <Box sx={{ mb: 3 }}>
      {/* Assumptions */}
      <Paper
        elevation={0}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 3,
          p: 3,
          mb: 2
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
          {t.assumptionsTitle}
        </Typography>

        {/* Included assumptions */}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          {t.basedOn}
        </Typography>
        <Box sx={{ mb: 3 }}>
          {ASSUMPTIONS.included.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                py: 0.75
              }}
            >
              <CheckIcon
                sx={{
                  fontSize: 18,
                  color: 'success.main'
                }}
              />
              <Typography variant="body2">
                {language === 'my' ? item.my : item.en}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Excluded items */}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          {t.excludes}
        </Typography>
        <Box>
          {ASSUMPTIONS.excluded.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                py: 0.75
              }}
            >
              <CloseIcon
                sx={{
                  fontSize: 18,
                  color: 'error.main'
                }}
              />
              <Typography variant="body2">
                {language === 'my' ? item.my : item.en}
              </Typography>
            </Box>
          ))}
        </Box>
      </Paper>

      {/* Disclaimer */}
      <Alert
        severity="warning"
        icon={<WarningAmberIcon />}
        sx={{
          borderRadius: 3,
          '& .MuiAlert-icon': {
            alignItems: 'flex-start',
            pt: 1
          }
        }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
          {disclaimer.title}
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2, mb: 2 }}>
          {disclaimer.content.map((item, index) => (
            <Typography
              component="li"
              variant="body2"
              key={index}
              sx={{ mb: 0.5 }}
            >
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
          {disclaimer.footer}
        </Typography>
      </Alert>
    </Box>
  );
};

export default AssumptionsDisclaimer;
